import React, {useEffect, useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import Card from "../../../common/Card";
import ReactHighcharts from "react-highcharts";

const useStyles = makeStyles(theme => ({

}));

const RecebidoFinalizadoChart = (
        series
) => {
    const classes = useStyles();

    var acat = [];
    var arec = [];
    var afin = [];

 //   console.log("SERIES", series.series);

    series.series.map( (d) => {
        acat.push(d.Data? d.Data.substring(0,10)  : 'N/A');
        arec.push(d.qtdeRecebidos? d.qtdeRecebidos : 0);
        afin.push(d.qtdeFinalizados? d.qtdeFinalizados : 0);
    });

    var config = {
        chart: {

            zoomType: 'x'
        },
        legend: {
            enabled: true
        },
        title: {
            text: 'Pneus Recebidos X Finalizados'
        },
        xAxis: {
            categories: acat,
            title: {
                text: ''
            }
        },
        plotOptions: {

            column: {
                stacking: 'normal',
                dataLabels: {
                    enabled: true,
                    color: 'blue',
                    format: '{point.y:.0f}',
                    rotation: 270
                }
            }
        },
        yAxis: [{
            title: {
                text: ''
            },
            type: 'logarithmic',
        }],
        series: [{
            type: 'column',
            data: afin,
            name: 'Finalizados',
            zIndex: 1,
        }, {
            type: 'spline',
            zIndex: 2,
            name: 'Recebidos',
            data: arec
        }]
    };



    return(
        <React.Fragment>
            <Card>
                <ReactHighcharts config = {config}>
                </ReactHighcharts>

            </Card>
        </React.Fragment>
    );
}

export default RecebidoFinalizadoChart;
